import { differenceInSeconds } from 'date-fns';

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
};

export function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  let y = elm.offsetTop;
  let node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  let elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  let startY = currentYPosition(scrollableElement);
  let stopY = elmYPosition(elm);

  let distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  let speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  let step = Math.round(distance / 25);
  let leapY = stopY > startY ? startY + step : startY - step;
  let timer = 0;
  if (stopY > startY) {
    for (let i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substr(2, tempId.length - 1);
  return uid;
}

export function getQueryParam(prop) {
  let params = {};
  let search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf('?') + 1)
  );
  let definitions = search.split('&');
  definitions.forEach(function (val, key) {
    let parts = val.split('=', 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(' ');
}

export const flat = (array) => {
  let result = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = result.concat(flat(a.children));
    }
  });
  return result;
};

export const getStatus = (status) => {
  switch (status) {
    case 0:
      return 'Pending';
    case 1:
      return 'Offline';
    case 2:
      return 'Disable';
    case 3:
      return 'live';
    default:
      return 'Unknown';

  }
}

export const getOrderStatus = (status) => {
  switch (status) {
    case 0:
      return 'Pending';
    case 1:
      return 'On-Hold';
    case 2:
      return 'Processing';
    case 3:
      return 'Completed';
    case 4:
      return 'Cancelled';
    case 5:
      return 'Refunded';
    case 6:
      return 'Failed';
    default:
      return 'Unknown';

  }
}

export const getOrderStatusColor = (status) => {
  switch (status) {
    case "order_delivered":
      return 'green';
    case 'order_cancel':
      return 'red';
    default:
      return '#e86240';
  }
}

export const getStatusColor = (status) => {
  switch (status) {
    case 0:
      return '#facd48';
    case 1:
      return '#3865a3';
    case 2:
      return '#e03c30';
    case 3:
      return '#64a338';
    default:
      return '#87a2c7';

  }
}

export const timeStampToDate = (UNIX_timestamp) => {

  let a = new Date(parseInt(`${UNIX_timestamp}`));
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  return date + '-' + month + '-' + year;
}

export const checkRoleExist = (item) => {
  let exist = false;
  const value = window.localStorage.getItem('user')
  if (value) {
    const user = JSON.parse(value);

    if (user?.service_area_id) {
      const zoonAccess = [
        'Orders',
        "Riders",
        "Sellers",
        "Customers",
        "products",
      ];
      const haveZoonAccess = zoonAccess.find(x => x === item);

      if (haveZoonAccess) {
        return true;
      }

      return false;
    }


    if (user.role === 0) {
      return true;
    }

    (user.user_dashboards || []).map(role => {

      if (role.access === item) {
        exist = true;
      }
    });
  }
  return exist;
}

export const checkWriteRole = (item) => {
  const value = window.localStorage.getItem('user')
  let exist = false;
  if (value) {
    const user = JSON.parse(value);

    if (user.role === 0) {
      return true;
    }
    (user.user_dashboards || []).map(role => {
      if (role.access === item) {
        if (role.write_access) {
          exist = true;
        }
      }
    });
  }
  return exist;
}



// status format
export function statusFormat(status) {
  return String(status).split('_').join(" ")
}


// make slug from title
export function generateSlug(title) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
}
